import { OrderStatus } from '../../interfaces/order-status.interface';
import { StatusType } from '../../order.types';

export const shouldForceUpdateOrder = (orderStatus?: OrderStatus) =>
  orderStatus === StatusType.DRAFT || orderStatus === StatusType.SUGGESTED;
